import { CheckboxAdapter } from 'components/enhanced/form/adapters/CheckboxAdapter';
import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import { MultipleAutocompleteAdapter } from 'components/enhanced/form/adapters/selects/MultipleAutocompleteAdapter';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { required } from 'components/helpers/validators';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { laboratoryService } from 'shared/services';
import { Option } from 'shared/types/general';
import { IWarehouse } from '../../types';
import { italianDistricts } from 'shared/constant';

interface LaboratoryFormParams {
  warehouse: IWarehouse;
  onSubmit: any;
  disableEdit?: boolean;
}
function WarehouseForm(params: LaboratoryFormParams) {
  const { t } = useTranslation();

  const [laboratories, setLaboratories] = useState<Option[]>([]);

  useEffect(() => {
    laboratoryService.getAllBaseInformation().then(setLaboratories);
  }, []);

  const { warehouse, onSubmit, disableEdit } = params;
  return (
    <div>
      {warehouse && (
        <EnhancedForm
          onSubmit={disableEdit ? {} : onSubmit}
          edit={!!warehouse.id}
          disableEdit={disableEdit}
          autoStyleLayout={true}
          columns={4}>
          <IdentityField
            name="code"
            initialValue={warehouse.code}
            component={TextFieldAdapter}
            label={t('global.code')}
            type="text"
            validate={required}
            disabled={disableEdit}
          />
          <IdentityField
            gridSpan={3}
            name="description"
            initialValue={warehouse.description}
            component={TextFieldAdapter}
            label={t('global.description')}
            type="text"
            validate={required}
            disabled={disableEdit}
          />
          <IdentityField
            gridSpan={2}
            name="city"
            initialValue={warehouse.city}
            component={TextFieldAdapter}
            label={t('entities.warehouse.city')}
            type="text"
            disabled={disableEdit}
          />
          <IdentityField
            name="district"
            component={AutocompleteAdapter}
            initValue={italianDistricts.find((s) => s.code === warehouse.district)}
            options={italianDistricts}
            optionValue={'code'}
            label={t('entities.warehouse.district')}
            type="text"
            disabled={disableEdit}
          />
          <IdentityField
            name="zip_code"
            initialValue={warehouse.zip_code}
            component={TextFieldAdapter}
            label={t('entities.warehouse.zip_code')}
            type="text"
            disabled={disableEdit}
          />
          <IdentityField
            gridSpan={2}
            name="address"
            initialValue={warehouse.address}
            component={TextFieldAdapter}
            label={t('entities.warehouse.address')}
            type="text"
            disabled={disableEdit}
          />
          <IdentityField
            name="address_2"
            initialValue={warehouse.address_2}
            component={TextFieldAdapter}
            label={t('entities.warehouse.address_2')}
            type="text"
            disabled={disableEdit}
          />
          <IdentityField
            name="phone_number"
            initialValue={warehouse.phone_number}
            component={TextFieldAdapter}
            label={t('entities.warehouse.phone_number')}
            type="text"
            disabled={disableEdit}
          />
          <IdentityField
            name="order_prefix"
            initialValue={warehouse.order_prefix}
            component={TextFieldAdapter}
            label={t('entities.warehouse.order_prefix')}
            type="text"
            disabled={disableEdit}
          />
          <IdentityField
            gridSpan={2}
            name="additional_details"
            initialValue={warehouse.additional_details}
            component={TextFieldAdapter}
            label={t('global.additional_details')}
            type="text"
            disabled={disableEdit}
          />
          <IdentityField
            name="opening_hours"
            initialValue={warehouse.opening_hours}
            component={TextFieldAdapter}
            label={t('global.opening_hours')}
            type="text"
            disabled={disableEdit}
          />
          <IdentityField
            gridSpan={2}
            name="contact"
            initialValue={warehouse.contact}
            component={TextFieldAdapter}
            label={t('global.contact')}
            type="text"
            disabled={disableEdit}
          />
          <IdentityField
            gridSpan={2}
            name="contact_2"
            initialValue={warehouse.contact_2}
            component={TextFieldAdapter}
            label={t('global.contact_2')}
            type="text"
            disabled={disableEdit}
          />
          <IdentityField
            gridSpan={4}
            name="order_confirmation_email"
            initialValue={warehouse.order_confirmation_email}
            component={TextFieldAdapter}
            label={t('entities.warehouse.order_confirmation_email')}
            placeholder="mario.verdi@mail.it; francesco.bianchi@mail.it; franco.rossi@mail.it"
            type="text"
            disabled={disableEdit}
          />
          <IdentityField
            gridSpan={4}
            name="cc"
            initialValue={warehouse.cc}
            component={TextFieldAdapter}
            label={t('entities.warehouse.cc')}
            placeholder="mario.verdi@mail.it; francesco.bianchi@mail.it; franco.rossi@mail.it"
            type="text"
            disabled={disableEdit}
          />
          <IdentityField
            gridSpan={4}
            name="notes"
            initialValue={warehouse.notes}
            component={TextFieldAdapter}
            label={t('global.notes')}
            type="text"
            disabled={disableEdit}
          />
          {laboratories && (
            <IdentityField
              gridSpan={3}
              name="laboratories"
              component={MultipleAutocompleteAdapter}
              options={laboratories}
              initValue={warehouse.laboratories}
              label={t('global.laboratories')}
              type="text"
              disabled={disableEdit}
            />
          )}
          <IdentityField
            name="fiscal"
            initialValue={warehouse.fiscal}
            component={CheckboxAdapter}
            label={t('global.fiscal')}
            type="checkbox"
            disabled={disableEdit}
          />
        </EnhancedForm>
      )}
    </div>
  );
}

export default WarehouseForm;
